const create_query_params = (filters) => {
	// Iterate [key-value] pairs of the object
	return Object.entries(filters)
		// Filter the pairs where the value is not an empty string
		.filter(([_, value]) => value !== '')
		// Transform to "key=value"
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
		// Join with '&'
		.join('&');
};

export default create_query_params;
